module.exports = __webpack_public_path__ + "static/media/favicon.7656a6d1.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/favicon.ico
// module id = 714
// module chunks = 0